// @flow

const sraDocuments = {
  type: 'sraDocuments',
  selecting: true,
  selectAll: true,
  actions: [
    {
      icon: 'Delete',
      title: 'Delete',
      method: 'delete'
    }
  ],
  row: {
    click: true,
    action: 'modal',
    modal: {
      app: 'myCompany',
      tab: 'sraDocumentsInfo'
    }
  },
  cells: [
    { id: 'name', label: 'Name', align: 'left' },
    { id: 'created_date', label: 'Created', align: 'left' },
    { id: 'modified_date', label: 'Modified', align: 'left' },
    {
      id: 'attachment_link',
      label: 'Download',
      labelAlign: 'center',
      align: 'center',
      button: true,
      val: 'attachment_link',
      renderDowloadIcon: true,
      hideOrderBy: true
    }
  ]
};

export default sraDocuments;
